// LiveRoomParticipant Model
import { Model } from '@vuex-orm/core';

export default class LiveRoomParticipant extends Model {
    // This is the name used as module name of the Vuex Store.
    static entity = 'liveroomparticipants'

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields() {
        return {
            id: this.attr(null),
            live_room_id: this.attr(null),
            user_id: this.attr(null),
            tenant_id: this.attr(null),
            room_admin: this.boolean(false),
            can_publish: this.boolean(false),
            can_subscribe: this.boolean(true),
            can_publish_data: this.boolean(false),
            hidden: this.boolean(false),
            access_token: this.attr(''),
            deleted_at: this.attr(''),
            created_at: this.attr(''),
            updated_at: this.attr(''),
        };
    }

    static apiConfig = {
        actions: {
            fetchById(id) {
                return new Promise((resolve, reject) => {
                    this.get(`/api/v3/live-room-participants/${id}`, {
                        dataTransformer: (response) => response.data.data
                    }).then((response) => {
                        resolve(true);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },
        },
    }
}

window.LiveRoomParticipant = LiveRoomParticipant;
